import React, { useState } from "react"

type useCaseRateRenewalsReturn = {
  openGatedAccountModal: boolean
  // @ts-expect-error TS(7051) FIXME: Parameter has a name but no type. Did you mean 'ar... Remove this comment to see the full error message
  setOpenGatedAccountModal: (boolean) => void
  // @ts-expect-error TS(7051) FIXME: Parameter has a name but no type. Did you mean 'ar... Remove this comment to see the full error message
  setRequestError: (boolean) => void
  requestError: boolean
  // @ts-expect-error TS(7051) FIXME: Parameter has a name but no type. Did you mean 'ar... Remove this comment to see the full error message
  setDisableModalCloseOnLoading: (boolean) => void
  disableModalCloseOnLoading: boolean
}

export enum AdvancedCheckInEmailLinkQueryString {
  REFRESH_PLAN = "refresh-plan-email-link",
  KEEP_PLAN = "keep-plan-email-link"
}

export const AdvancedCheckInWarningQueryString = "advanced-check-in-warning"

const CaseRateRenewalsContext = React.createContext(null)
export const useCaseRateRenewals = (): useCaseRateRenewalsReturn => React.useContext(CaseRateRenewalsContext)

export function CaseRateRenewalsContextProvider({
  children,
  shouldCrrModalRender
}: {
  children: React.ReactElement
  shouldCrrModalRender: boolean
}): JSX.Element {
  const [requestError, setRequestError] = useState(false)
  const [openGatedAccountModal, setOpenGatedAccountModal] = useState(shouldCrrModalRender)
  const [disableModalCloseOnLoading, setDisableModalCloseOnLoading] = useState(false)

  return (
    <CaseRateRenewalsContext.Provider
      value={{
        openGatedAccountModal,
        setOpenGatedAccountModal,
        setRequestError,
        requestError,
        disableModalCloseOnLoading: disableModalCloseOnLoading,
        setDisableModalCloseOnLoading: setDisableModalCloseOnLoading
      }}
    >
      {children}
    </CaseRateRenewalsContext.Provider>
  )
}
